(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["metafield-options"] && !Shopify.designMode) return;
  try {
    (() => {
  const syncRoot = (root, form) => {
    const groups = root.querySelectorAll('fieldset[data-property-name]');
    groups.forEach((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      const propertyName = group.dataset.propertyName;
      if (!checked || !propertyName) return;
      const forms = form ? [form] : document.querySelectorAll('form[data-type="add-to-cart-form"]');
      forms.forEach((targetForm) => {
        if (!(targetForm instanceof HTMLFormElement)) return;
        let input = targetForm.querySelector(`input[data-metafield-property="${CSS.escape(propertyName)}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${propertyName}]`;
          input.dataset.metafieldProperty = propertyName;
          targetForm.appendChild(input);
        }
        input.value = checked.value;
      });
    });
  };

  const syncAll = (form) => {
    document.querySelectorAll('[data-metafield-options]').forEach((root) => {
      syncRoot(root, form);
    });
  };

  const bind = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    root.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
      const group = target.closest('fieldset');
      if (!group) return;
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        const wasCurrent = input.dataset.currentChecked === 'true';
        input.dataset.previousChecked = wasCurrent ? 'true' : 'false';
        input.dataset.currentChecked = input.checked ? 'true' : 'false';
      });
      const swatchValue = group.querySelector('.variant-option__swatch-value');
      if (swatchValue) swatchValue.textContent = target.value;
      syncRoot(root);
    });
    syncRoot(root);
  };

  const init = () => {
    document.querySelectorAll('[data-metafield-options]').forEach(bind);
    syncAll();
  };

  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('button[name="add"], button[type="submit"]');
      if (!button) return;
      const form = button.form || button.closest('form[data-type="add-to-cart-form"]');
      if (form instanceof HTMLFormElement && form.dataset.type === 'add-to-cart-form') syncAll(form);
    },
    true
  );
})();
  } catch(e) { console.error(e); }
})();

})();
